import type { MeasureWallOutline } from "./types";

const BAR_CORNERS = 4;

// A wall run is a four-corner bar: its longest side is the length, its shortest the thickness.
export const measureWallOutline: MeasureWallOutline = ({
  points,
  metersPerPdfPoint,
}) => {
  if (points.length !== BAR_CORNERS || metersPerPdfPoint <= 0) return null;

  let longest = 0;
  let shortest = Infinity;
  for (let index = 0; index < BAR_CORNERS; index++) {
    const start = points[index];
    const end = points[(index + 1) % BAR_CORNERS];
    const side = Math.hypot(end.x - start.x, end.y - start.y);
    if (side > longest) longest = side;
    if (side < shortest) shortest = side;
  }

  return {
    lengthM: longest * metersPerPdfPoint,
    thicknessM: shortest * metersPerPdfPoint,
  };
};
